import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./AdNumber.module.css";
var AdNumber = function AdNumber(props) {
  var _useTranslation = useTranslation(["web_post_view"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, t("رقم الأعلان:", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, props.adNumber)), !props.isTrackingView && /*#__PURE__*/React.createElement("p", null, t("أذكر رقم الأعلان عند الاتصال مع خدمة العملاء", {
    ns: "web_post_view"
  }))));
};
export default AdNumber;